import { t } from 'ttag';
import './index.scss';

const NotFound = ({ message }) => (
    <div id='not-found'>
        <h1>
            {t`NOT_FOUND_TITLE`}
        </h1>
        <p>
            {message || t`DEFAULT_NOT_FOUND_MESSAGE`}
        </p>
    </div>
);


export default NotFound;
